(() => {
  'use strict';

  if (!window.gemmariiEngravingEventsBound) {
    window.gemmariiEngravingEventsBound = true;

    const getGroupForInput = (input) => input?.nextElementSibling?.matches('[data-engraving-target]') ? input.nextElementSibling : null;

    const activateEngravingSymbols = (input) => {
      const engraving = input.closest('.gemmarii-engraving');
      if (!engraving) return;

      engraving.querySelectorAll('[data-engraving-target]').forEach((group) => {
        group.classList.toggle('is-active', group === getGroupForInput(input));
      });
    };

    const insertEngravingSymbol = (button) => {
      const group = button.closest('[data-engraving-target]');
      const engraving = group?.closest('.gemmarii-engraving');
      const input = engraving?.querySelector(`input[data-gemmarii-engraving="${group.dataset.engravingTarget}"]`);
      if (!input) return;

      const symbol = button.dataset.engravingSymbol || '';
      const start = input.selectionStart ?? input.value.length;
      const end = input.selectionEnd ?? start;

      input.setRangeText(symbol, start, end, 'end');
      input.dispatchEvent(new Event('input', { bubbles: true }));
    };

    document.addEventListener('focusin', (event) => {
      const input = event.target.closest?.('input[data-gemmarii-engraving]');
      if (!input || getGroupForInput(input)?.classList.contains('is-active')) return;
      activateEngravingSymbols(input);
    });

    document.addEventListener('pointerdown', (event) => {
      const button = event.target.closest?.('button[data-engraving-symbol]');
      if (button) {
        event.preventDefault();
        insertEngravingSymbol(button);
        return;
      }

      const input = event.target.closest?.('input[data-gemmarii-engraving]');
      if (input) {
        activateEngravingSymbols(input);
        return;
      }

      const engraving = event.target.closest?.('.gemmarii-engraving');
      if (!engraving) {
        document.querySelectorAll('.gemmarii-engraving__symbols.is-active').forEach((group) => group.classList.remove('is-active'));
      }
    });
  }
})();
